// 2_components/menu.js
// Main category menu: overflow detection moving items into a custom
// "menu-helper" submenu, mobile multi-level menu behavior, footer contacts/links
// clones in the mobile menu, comma cleanup and "show all categories" buttons.

let mainCategoryMenu;
let mainCategoryMenuItems;
let mainCategoryMenuHelper;
let mainCategoryMenuHelperSubmenuDiv;
let mainCategoryMenuHelperSubmenu;
let menuLevelsTwo;
let menuLevelsThree;
let mobileMenuIsTriggered = false;
let addedListenerToClickOutsideOfMenu = false;

export function init() {
	if (!window.NAT?.utils?.addSmartTouchClickListener) {
		console.warn("[NAT] menu.js: window.NAT.utils.addSmartTouchClickListener missing — check load order");
		return;
	}

	const header = document.getElementById("header");
	mainCategoryMenu = header.querySelector(".menu-level-1");
	mainCategoryMenuItems = mainCategoryMenu.querySelectorAll(":scope > li");
	const originalMainCategoryMenuHelper = header.querySelector(".menu-helper");
	const textOfOriginalMainCategoryMenuHelper = originalMainCategoryMenuHelper.innerHTML;
	header.querySelector(".menu-helper").remove();
	mainCategoryMenuHelper = document.createElement("div");
	mainCategoryMenuHelper.className = "menu-helper-custom";
	mainCategoryMenuHelper.innerHTML = textOfOriginalMainCategoryMenuHelper;
	mainCategoryMenuHelperSubmenuDiv = document.createElement("div");
	mainCategoryMenuHelperSubmenuDiv.className = "menu-helper-submenu";
	mainCategoryMenuHelper.appendChild(mainCategoryMenuHelperSubmenuDiv);
	mainCategoryMenuHelperSubmenu = mainCategoryMenuHelper.querySelector(".menu-helper-submenu");

	mainCategoryMenu.appendChild(mainCategoryMenuHelper);

	inicializeMenu();

	document.addEventListener("resizeX", function () {
		inicializeMenu();
	});

	/*-------------------------------------- HEADER SUBMENU LISTENER (mainly for mobile)*/
	window.NAT.utils.addSmartTouchClickListener(mainCategoryMenuHelper, function (event) {
		mainCategoryMenuHelper.classList.toggle("active");
		mainCategoryMenuHelperSubmenuDiv.classList.toggle("active");

		if (window.NAT.media.isMobile) {
			document.body.classList.toggle("scroll-lock");
			document.body.classList.toggle("content-hidden");
			mainCategoryMenu.querySelectorAll(".menu-helper-submenu .active").forEach((activeItems) => {
				activeItems.classList.remove("active");
			});
			mainCategoryMenuHelperSubmenu.classList.remove("level-two-active");
			mainCategoryMenuHelperSubmenu.classList.remove("level-three-active");
		}

		if (!addedListenerToClickOutsideOfMenu) {
			addedListenerToClickOutsideOfMenu = true;
			window.NAT.utils.addSmartTouchClickListener(document, function (event) {
				if (!mainCategoryMenuHelperSubmenuDiv.contains(event.target) && !mainCategoryMenuHelper.contains(event.target)) {
					mainCategoryMenuHelper.classList.remove("active");
					mainCategoryMenuHelperSubmenuDiv.classList.remove("active");
					if (window.NAT.media.isMobile) {
						document.body.classList.remove("scroll-lock");
						document.body.classList.remove("content-hidden");
					}
				}
			});
		}
	});

	removeCommasFromMenu();
}

function inicializeMenu() {
	if (window.NAT.media.isMobile) {
		if (mobileMenuIsTriggered) {
			return;
		}
		mobileMenuIsTriggered = true;
		mainCategoryMenuItems.forEach((item) => {
			mainCategoryMenuHelperSubmenu.appendChild(item);
		});
		mainCategoryMenu.append(mainCategoryMenuHelperSubmenu);

		mainCategoryMenuHelper.classList.remove("active");
		mainCategoryMenuHelperSubmenuDiv.classList.remove("active");

		menuLevelsTwo = mainCategoryMenu.querySelectorAll(".menu-level-2");
		menuLevelsTwo.forEach((menuLevelTwo) => {
			window.NAT.utils.addSmartTouchClickListener(menuLevelTwo, function (event) {
				if (window.NAT.media.isMobile) {
					menuLevelTwo.classList.add("active");
					menuLevelTwo.parentElement.classList.add("active");
					mainCategoryMenuHelperSubmenu.classList.add("level-two-active");

					// mainCategoryMenuHelperSubmenuDiv scroll to top
					mainCategoryMenuHelperSubmenuDiv.scrollTop = 0;
				}
			});
		});

		menuLevelsThree = mainCategoryMenu.querySelectorAll(".menu-level-3");
		menuLevelsThree.forEach((menuLevelThree) => {
			window.NAT.utils.addSmartTouchClickListener(menuLevelThree, function (event) {
				if (!window.NAT.media.isMobile) {
					return;
				}
				menuLevelThree.classList.add("active");
				menuLevelThree.parentElement.parentElement.classList.add("active");
				mainCategoryMenuHelperSubmenu.classList.add("level-three-active");

				mainCategoryMenuHelperSubmenuDiv.scrollTop = 0;
			});
		});

		const liHasThirdLevel = mainCategoryMenu.querySelectorAll(".has-third-level");
		liHasThirdLevel.forEach((item) => {
			const aElement = item.querySelector(":scope > div > a");
			window.NAT.utils.addSmartTouchClickListener(aElement, function (event) {
				if (!window.NAT.media.isMobile) {
					return;
				}
				if (item.classList.contains("active")) {
					event.preventDefault();
					mainCategoryMenuHelperSubmenu.classList.remove("level-three-active");
					item.querySelector(".menu-level-3").classList.remove("active");
					item.classList.remove("active");
					mainCategoryMenuHelperSubmenuDiv.scrollTop = 0;
				}
			});
		});

		const liHasSecondLevel = mainCategoryMenu.querySelectorAll("li.ext");
		liHasSecondLevel.forEach((item) => {
			const aElement = item.querySelector(":scope > a");
			window.NAT.utils.addSmartTouchClickListener(aElement, function (event) {
				if (!window.NAT.media.isMobile) {
					return;
				}
				if (item.classList.contains("active")) {
					event.preventDefault();
					mainCategoryMenuHelperSubmenu.classList.remove("level-two-active");
					item.querySelector(".menu-level-2").classList.remove("active");
					item.classList.remove("active");
					mainCategoryMenuHelperSubmenuDiv.scrollTop = 0;
				}
			});
		});

		copyFooterContactsToHeader();
		copyFooterLinksToHeader();

		function copyFooterContactsToHeader() {
			const footerContactBlock = document.querySelector(".top-navigation-contacts");
			if (footerContactBlock) {
				const footerContactBlockClone = footerContactBlock.cloneNode(true);
				footerContactBlockClone.classList.add("top-navigation-contacts-clone");
				mainCategoryMenuHelperSubmenu.appendChild(footerContactBlockClone);
			}
		}

		function copyFooterLinksToHeader() {
			const customerLinks = document.querySelector(".customer-links");
			const aboutUsLinks = document.querySelector(".about-us-links");

			if (customerLinks) {
				const customerLinksClone = customerLinks.cloneNode(true);
				customerLinksClone.classList.add("customer-links-clone");
				mainCategoryMenuHelperSubmenu.appendChild(customerLinksClone);
			}

			if (aboutUsLinks) {
				const aboutUsLinksClone = aboutUsLinks.cloneNode(true);
				aboutUsLinksClone.classList.add("about-us-links-clone");
				mainCategoryMenuHelperSubmenu.appendChild(aboutUsLinksClone);
			}
		}

		return;
	}

	if (!window.NAT.media.isMobile && mobileMenuIsTriggered) {
		mainCategoryMenuHelper.append(mainCategoryMenuHelperSubmenu);
		mainCategoryMenu.querySelectorAll(".active").forEach((activeItems) => {
			activeItems.classList.remove("active");
		});
		mainCategoryMenuHelperSubmenu.classList.remove("level-two-active");
		mainCategoryMenuHelperSubmenu.classList.remove("level-three-active");
		document.body.classList.remove("scroll-lock");
		document.body.classList.remove("content-hidden");
		mobileMenuIsTriggered = false;
	}

	const mainCategoryMenuItemsInSubmenu = mainCategoryMenuHelperSubmenu.querySelectorAll(":scope > li");
	if (mainCategoryMenuItemsInSubmenu.length > 0) {
		mainCategoryMenuItemsInSubmenu.forEach((item) => {
			mainCategoryMenu.appendChild(item);
		});
		mainCategoryMenu.appendChild(mainCategoryMenuHelper);
	}

	const mainCategoryMenuItemsWidth = [];
	let cumulativeMainCategoryMenuItemWidth = 0;
	const mainCategoryMenuHelperWidth = mainCategoryMenuHelper.offsetWidth;

	mainCategoryMenuItems.forEach((item) => {
		const itemWidth = item.offsetWidth;
		cumulativeMainCategoryMenuItemWidth += itemWidth;
		mainCategoryMenuItemsWidth.push(cumulativeMainCategoryMenuItemWidth);
	});

	const mainCategoryMenuWidth = mainCategoryMenu.offsetWidth;

	if (mainCategoryMenuWidth < cumulativeMainCategoryMenuItemWidth) {
		mainCategoryMenuHelper.classList.remove("menu-helper-hidden");
		const indexOfOverflowItem = mainCategoryMenuItemsWidth.findIndex(
			(itemWidth) => itemWidth > mainCategoryMenuWidth - mainCategoryMenuHelperWidth,
		);

		// from this index onwards, hide the items with style.display = "none"
		for (let i = indexOfOverflowItem; i < mainCategoryMenuItems.length; i++) {
			mainCategoryMenuHelperSubmenu.appendChild(mainCategoryMenuItems[i]);
		}
	} else {
		mainCategoryMenuHelper.classList.add("menu-helper-hidden");
	}
}

/*-------------------------------------- MENU MAXIMUM ITEMS*/
function removeCommasFromMenu() {
	mainCategoryMenuItems.forEach((item) => {
		const menuLinkHref = item.querySelector(":scope > a")?.getAttribute("href") || null;

		const menuLevelTwo = item.querySelector(".menu-level-2");
		const menuLevelTwoLi = item.querySelectorAll(".menu-level-2 > li");

		if (menuLevelTwoLi.length > 0) {
			if (menuLevelTwoLi.length > 12) {
				for (let i = 11; i < menuLevelTwoLi.length; i++) {
					menuLevelTwoLi[i].style.display = "none";
				}
				const numberOfHiddenItems = menuLevelTwoLi.length - 12 + 1;
				const showAllCategoriesButton = document.createElement("a");
				showAllCategoriesButton.setAttribute("href", menuLinkHref);
				showAllCategoriesButton.className = "show-all-categories";

				showAllCategoriesButton.innerHTML =
					"<span>" + window.NAT.translations("showAllCategories") + " (" + numberOfHiddenItems + ")</span>";

				menuLevelTwo.appendChild(showAllCategoriesButton);
			}

			menuLevelTwoLi.forEach((li, index) => {
				const menuLevelThreeLinkHref = li.querySelector(":scope > a")?.getAttribute("href") || null;
				const menuLevelThree = li.querySelector(".menu-level-3");
				const menuLevelThreeLi = li.querySelectorAll(".menu-level-3 > li");

				// Remove the comma from menu level 3
				if (menuLevelThreeLi.length > 0) {
					if (menuLevelThreeLi.length > 4) {
						for (let i = 3; i < menuLevelThreeLi.length; i++) {
							menuLevelThreeLi[i].style.display = "none";
						}

						const numberOfHiddenItems = menuLevelThreeLi.length - 4 + 1;
						const showAllSubcategoriesButton = document.createElement("a");
						showAllSubcategoriesButton.setAttribute("href", menuLevelThreeLinkHref);
						showAllSubcategoriesButton.className = "show-all-subcategories";

						if (numberOfHiddenItems > 4) {
							showAllSubcategoriesButton.innerHTML =
								"+ " + window.NAT.translations("moreButtonMoreThanFour") + " " + numberOfHiddenItems;
						} else if (numberOfHiddenItems == 1) {
							showAllSubcategoriesButton.innerHTML =
								"+ " + window.NAT.translations("moreButtonOne") + " " + numberOfHiddenItems;
						} else {
							showAllSubcategoriesButton.innerHTML =
								"+ " + window.NAT.translations("moreButtonLessThanFour") + " " + numberOfHiddenItems;
						}

						menuLevelThree.appendChild(showAllSubcategoriesButton);
					}
					menuLevelThreeLi.forEach((li) => {
						let liHTML = li.innerHTML;
						liHTML = liHTML.replace(/<\/a>,\s*<\/li>$/, "</a></li>");
						liHTML = liHTML.replace(/<\/a>,\s*$/, "</a>");
						li.innerHTML = liHTML;
					});
				}
			});
		}
	});
}
